
module.exports = function getResource(label, vars = []) {
    let resources = {
        shopFaves: 'Shop Your Favorites',
        viewAll: 'View all',
        fromLovesList: 'From your Loves list...'
    };
    return resources[label];
};
